import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { RemoveSchedulePerformanceReviewProcessDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'

export const RemoveScheduleReviewModal: React.FC<{
  reviewId: number
  name: string | null | undefined
  onClose?: () => void
}> = ({ reviewId, name, onClose }) => {
  const [removeScheduleReviewMutation, { loading: isLoading }] = useMutation(
    RemoveSchedulePerformanceReviewProcessDocument,
    {
      extractorFn: (data) => data.performanceMutations.removeSchedulePerformanceReviewProcess,
    }
  )

  const removeScheduleReview = async () => {
    const response = await removeScheduleReviewMutation({
      variables: {
        id: reviewId,
      },
    })

    const result = handleResult(response, () => null)
    onClose?.()
    return result
  }

  return (
    <Modal
      title={i18n.t('performance_process.reviews.unschedule_review_modal.title')}
      description={i18n.t('performance_process.reviews.unschedule_review_modal.description', {
        name: name || '',
      })}
      illustration="alert"
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose} disabled={isLoading}>
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={removeScheduleReview} disabled={isLoading}>
            {i18n.t('performance_process.reviews.unschedule_review_modal.action')}
          </Button>
        </>
      }
    ></Modal>
  )
}
